<template>
  <v-dialog v-model="dialogMail" width="800" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn outlined color="info" v-bind="attrs" v-on="on">
        E-Mail-Versand
      </v-btn>
    </template>

    <v-card :loading="loading">
      <v-system-bar color="danger">E-Mail: häufige Absenzen</v-system-bar>
      <v-card-text class="pa-0 mt-4">
        <v-list>
          <v-list-item dense>
            <v-select
              :items="templates"
              label="Vorlage E-Mail"
              outlined
              single-line
              hide-details
              item-text="title"
              item-value="content"
              v-model="template"
            ></v-select>
          </v-list-item>
          <v-list-item dense>
            <v-container>
              <v-row no-gutters>
                <v-col cols="1" class="text-right pr-2">betreff:</v-col>
                <v-col>{{ subject }}</v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="1" class="text-right pr-2">an:</v-col>
                <v-col>{{ joinEmails(to) }}</v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="1" class="text-right pr-2">cc:</v-col>
                <v-col>{{ joinEmails(cc) }}</v-col>
              </v-row>
            </v-container>
          </v-list-item>
          <v-list-item class="pa-0">
            <v-textarea
              outlined
              readonly
              label="E-Mail"
              rows="10"
              :value="mail"
              class="px-4"
            ></v-textarea>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn text @click="dialogMail = false">schliessen </v-btn>
        <v-spacer></v-spacer>
        <v-btn :loading="saving" color="primary" text :href="mailto"
          >in App öffnen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from "vue";
import { joinEmails } from "common/utils/helper";

export default defineComponent({
  components: {},
  props: ["item", "absences"],
  data() {
    return {
      dialogMail: false,
      loading: false,
      saving: false,
      parents: [],
      templates: [
        {
          title: "Mehr als 35 Lektionen gefehlt, ohne Massnahmen",
          content: `Ein kontinuierlicher Besuch des Unterrichts ist ein wichtiger Faktor, um die Matur erfolgreich zu bestehen. Deshalb achten wir darauf, dass unsere Schüler*innen den Unterricht regelmässig besuchen. Ab einer Anzahl von 35 Lektionen, also etwa einem Wochenpensum, werden Abwesenheiten der Schulleitung gemeldet.

{{student}} hat im laufenden Schuljahr diese 35 Lektionen bereits erreicht/überschritten.

{{repeatedViolation}}Da diese Abwesenheiten jedoch nachvollziehbar und begründet sind, erfolgen zum jetzigen Zeitpunkt keine weiteren Massnahmen ausser der Ablage dieser Meldung im Schüler*innendossier.

Mit freundlichen Grüssen
`,
        },
        {
          title: "Mehr als 35 Lektionen gefehlt, mit Massnahmen",
          content: `Ein kontinuierlicher Besuch des Unterrichts ist ein wichtiger Faktor, um die Matur erfolgreich zu bestehen. Deshalb achten wir darauf, dass unsere Schüler*innen den Unterricht regelmässig besuchen. Ab einer Anzahl von 35 Lektionen, also etwa einem Wochenpensum, werden Abwesenheiten der Schulleitung gemeldet.

{{student}} hat im laufenden Schuljahr bereits {{absencesTotal}} Lektion gefehlt.

Eine Information zu den beschlossenen Massnahmen finden Sie im Anhang.

Mit freundlichen Grüssen
`,
        },
        {
          title: "Unentschuldigte Lektionen",
          content: `Ein kontinuierlicher Besuch des Unterrichts mit wenig Fehlzeiten ist ein wichtiger Faktor, um die Matur erfolgreich zu bestehen.

Darüber hinaus ist es wichtig, die Lehrpersonen vorgängig über Abwesenheiten zu informieren und Absenzen im Anschluss korrekt zu entschuldigen. Schüler*innen lernen an dieser Stelle u.a. für ihr späteres Berufsleben.

{{student}} hat im laufenden Schuljahr bereits {{absencesUnexcused}} Lektionen unentschuldigt gefehlt.

Eine Information zu den beschlossenen Massnahmen finden Sie im Anhang.

Mit freundlichen Grüssen
`,
        },
        {
          title: "Andere (leeres Mail, das ergänzt werden kann)",
          content:
            "(Text hier ergänzen)\nAbsenzen total: {{absencesTotal}}\nAbsenzen unentschuldigt: {{absencesUnexcused}}\n\nMit freundlichen Grüssen\n",
        },
      ],
      template: null,
    };
  },
  computed: {
    renderedTemplate() {
      if (!this.template) return "";
      let rendered = this.template;
      const placeholders = {
        "{{student}}":
          this.item.student.firstName + " " + this.item.student.lastName,
        "{{absencesTotal}}":
          this.absences.pendingLessons +
          this.absences.excusedLessons +
          this.absences.unexcusedLessons,
        "{{absencesUnexcused}}": this.absences.unexcusedLessons,
        "{{repeatedViolation}}": this.item.repeatedViolation
          ? `${this.item.student.firstName} ${this.item.student.lastName} fehlt weiterhin häufig im Unterricht.\n\n`
          : "",
      };
      for (const [placeholder, value] of Object.entries(placeholders)) {
        rendered = rendered.replace(new RegExp(placeholder, "g"), value);
      }
      return rendered;
    },
    mail() {
      if (!this.item || !this.template) return "";
      return this.salutation + "\n\n" + this.renderedTemplate + this.greetings;
    },
    to() {
      if (!this.item || !this.item.student || !this.item.student.emailSchool) {
        return [];
      }
      return [
        this.item.student.emailSchool,
        ...this.parents.map((p) => p.emailHome),
      ].filter(Boolean);
    },
    cc() {
      const cc = [];
      if (this.item && this.item.student && this.item.student.schoolClass) {
        cc.push(this.item.teacher.emailSchool);
        if (this.item.student.schoolClass.code.startsWith("G")) {
          cc.push(`ina.broekmann@gymkirchenfeld.ch`);
          cc.push(`irene.stucki@gymkirchenfeld.ch`);
        }
        if (this.item.student.schoolClass.code.startsWith("M")) {
          cc.push(`martin.lanz@gymkirchenfeld.ch`);
          cc.push(`sandra.mueller@gymkirchenfeld.ch`);
        }
        if (this.item.student.schoolClass.code.startsWith("W")) {
          cc.push(`samantha.wolf@gymkirchenfeld.ch`);
          cc.push(`irene.stucki@gymkirchenfeld.ch`);
        }
      }
      return cc;
    },
    subject() {
      if (!this.item || !this.item.student) {
        return "";
      }
      return `Häufige Absenzen ${this.item.student.firstName} ${this.item.student.lastName}`;
    },
    mailto() {
      if (!this.item || !this.item.student) {
        return [];
      }
      return `mailto:${joinEmails(this.to)}?cc=${encodeURIComponent(
        joinEmails(this.cc)
      )}&subject=${encodeURIComponent(this.subject)}&body=${encodeURIComponent(
        this.mail
      )}`;
    },
    salutation() {
      if (!this.item || !this.item.student || !this.item.student.gender) {
        return "Hallo";
      }
      let studentSalutation =
        this.item.student.gender.code == "F"
          ? "Liebe"
          : this.item.student.gender.code == "M"
          ? "Lieber"
          : "Hallo";

      let result = `${studentSalutation} ${this.item.student.firstName} ${this.item.student.lastName}`;

      if (this.parents.length > 0) {
        result += "\n\n";
        const parentSalutations = this.parents
          .sort((a, b) => {
            if (!a.firstName || !b.firstName) return 0;
            return a.role.localeCompare(b.role);
          })
          .map(
            (parent) =>
              `Sehr geehrte${parent.role === "Vater" ? "r Herr" : " Frau"} ${
                parent.lastName
              }`
          );
        result += parentSalutations.join(", ");
      }

      return result;
    },
    greetings() {
      if (this.item.student.schoolClass) {
        if (this.item.student.schoolClass.code.startsWith("G")) {
          return `Ina Broekmann\n\ni.A.`;
        }
        if (this.item.student.schoolClass.code.startsWith("M")) {
          return `Martin Lanz\n\ni.A.`;
        }
        if (this.item.student.schoolClass.code.startsWith("W")) {
          return `Samantha Wolf\n\ni.A.`;
        }
      }
      return "(Grussformel)";
    },
  },
  watch: {
    item() {
      this.fetchData();
    },
  },
  methods: {
    joinEmails,
    async fetchData() {
      this.loading = true;
      this.parents = await this.apiGet({
        resource: "person/legalguardian",
        id: this.item.student.id,
      });
      this.loading = false;
    },
  },
  onMounted() {
    this.fetchData();
  },
});
</script>
